<div class="stores">
  <div class="stores-content">
    <!-- Header Section -->
    <div class="stores-header">
      <div class="header-content">
        <div class="header-text">
          <h1 class="main-title">Agency Brands</h1>
          <p class="subtitle">Manage and switch between your brand accounts</p>
        </div>
        <button class="add-brand-btn" (click)="addBrand()">
          <span class="btn-text">Add brand</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading brands...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="error-container">
      <div class="error-message">
        <h3>Failed to load brands</h3>
        <p>{{ error }}</p>
        <button class="retry-btn" (click)="loadBots()">Try Again</button>
      </div>
    </div>

    <!-- Brand Cards -->
    <div *ngIf="!loading && !error" class="brands-container">
      <div 
        *ngFor="let bot of bots; trackBy: trackByBotId" 
        class="brand-card"
        [attr.data-bot-id]="bot.bot_id"
      >
        <div class="brand-info">
          <h3 class="brand-name">{{ bot.name }}</h3>
          <div class="brand-status">
            <span class="status-indicator"></span>
            <span class="status-text">Available</span>
          </div>
        </div>
        <button class="switch-btn" (click)="navigateToStore(bot.bot_id)">
          Switch to brand
        </button>
      </div>
    </div>

    <!-- Loading More Indicator -->
    <div *ngIf="loadingMore && !loading" class="loading-more-container">
      <div class="loading-spinner"></div>
      <p>Loading more brands...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && bots.length === 0" class="empty-state">
      <div class="empty-message">
        <h3>No brands found</h3>
        <p>There are no brand accounts available at the moment.</p>
      </div>
    </div>
  </div>
</div> 

<!-- Add Brand Modal -->
<div class="popup-overlay" [class.show]="showAddBrandModal" (click)="closeAddBrandModal()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h3>Add new brand</h3>
      <button class="close-btn" (click)="closeAddBrandModal()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    <div class="popup-divider"></div>
    <div class="popup-body">
      <div class="api-key-input">
        <label class="api-label">Brand Website URL</label>
        <div class="input-with-icon">
          <input 
            style="height: 60px;"
            type="text"
            placeholder="https://example.com"
            class="api-input"
            [(ngModel)]="newBrandUrl"
          />
          <span class="input-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_1_5295)">
                <path d="M8.29145 15.2438L5.93475 17.6005C4.95772 18.5776 3.37548 18.5776 2.39926 17.6007C1.42285 16.6243 1.42285 15.0419 2.39907 14.0657L7.11327 9.3515C8.08949 8.37524 9.67188 8.37524 10.6481 9.3515C10.9735 9.67693 11.5012 9.67693 11.8266 9.3515C12.1521 9.02607 12.1521 8.49841 11.8266 8.17298C10.1995 6.54586 7.56187 6.54586 5.93475 8.17298L1.22058 12.8871C-0.406536 14.5143 -0.406536 17.1519 1.22058 18.779C2.84751 20.407 5.48534 20.407 7.11331 18.779L9.47001 16.4223C9.79544 16.0969 9.79544 15.5692 9.47001 15.2438C9.14458 14.9184 8.61688 14.9184 8.29145 15.2438Z" fill="white"/>
                <path d="M18.7795 1.22034C17.1524 -0.40678 14.5139 -0.40678 12.8867 1.22034L10.0592 4.04786C9.73379 4.37329 9.73379 4.90095 10.0592 5.22638C10.3847 5.55181 10.9123 5.55181 11.2377 5.22638L14.0653 2.39886C15.0415 1.42261 16.6247 1.42261 17.6009 2.39886C18.5772 3.37508 18.5772 4.95747 17.6009 5.93369L12.4159 11.1188C11.4397 12.095 9.85731 12.095 8.88109 11.1188C8.55566 10.7933 8.028 10.7933 7.70257 11.1188C7.37714 11.4442 7.37714 11.9718 7.70257 12.2973C9.32969 13.9244 11.9673 13.9244 13.5944 12.2973L18.7795 7.11225C20.4066 5.48513 20.4066 2.84746 18.7795 1.22034Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_1_5295">
                  <rect width="20" height="20" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
        <p class="helper-text">Enter the website URL for your brand. We’ll automatically extract the brand name from the domain.</p>
      </div>
    </div>
    <div class="popup-footer">
      <button class="action-button secondary" type="button" (click)="closeAddBrandModal()">Cancel</button>
      <button class="action-button primary" type="button" [disabled]="isCreating || !newBrandUrl" (click)="confirmAddBrand()">
        {{ isCreating ? 'Continuing…' : 'Continue' }}
      </button>
    </div>
  </div>
</div>